import { useState, useRef, useImperativeHandle, forwardRef } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';

import DownImage from '../../image/down.png';
import UpImage from '../../image/up.png';
import SettingTimeSelectBox from './NewSettingTimeSelectBox';

const SettingCountInput = forwardRef((props, ref) => {
  const { text } = props;
  const { t } = useLanguage();

  const [dateVal, setDateVal] = useState(0);
  const [unit, setUnit] = useState({ name: 'min', label: t('system.min') });

  const InputRef = useRef();

  const options = [
    { name: 'hour', label: t('system.hour') },
    { name: 'min', label: t('system.min') }
  ];

  useImperativeHandle(ref, () => ({
    setValue: (val) => {
      setDateVal(val);
      setUnit({ name: 'min', label: t('system.min') });
    },
    setUnit: (val) => {
      if (val === 'min') setUnit({ name: 'min', label: t('system.min') });
      else if (val === 'time') setUnit({ name: 'hour', label: t('system.hour') });
      else setUnit({ name: 'day', label: t('system.day') });
    },
    getValue: () => {
      let multiplier = 1;

      if (unit.name === 'day') multiplier = 60 * 24;
      else if (unit.name === 'hour') multiplier = 60;
      else if (unit.name === 'min') multiplier = 1;

      return (dateVal * multiplier);
    },
    getUnit: () => {
      return unit.name;
    }
  }))

  // 입력값 변경시 //
  function onChangeInput(e) {
    const regex = /[^0-9]/g;
    const result = e.target.value.replace(regex, "");
    setDateVal(result === '' ? 0 : parseInt(result));
  }

  // 증가 버튼 클릭시 //
  function onClickUp() {
    setDateVal(dateVal + 1);
  }

  // 감소 버튼 클릭시 //
  function onClickDown() {
    if (dateVal > 0) setDateVal(dateVal - 1);
  }

  return (
    <TopLevelWrapper>
      <Input
        ref={InputRef}
        placeholder={0}
        value={dateVal}
        onChange={onChangeInput} />
      <ButtonWrapper>
        <Button img={UpImage} onClick={onClickUp} />
        <Button img={DownImage} onClick={onClickDown} />
      </ButtonWrapper>
      <SettingTimeSelectBox
        options={options}
        value={unit}
        setValue={setUnit}
        width={72} />
      <UnitText>{text}</UnitText>
    </TopLevelWrapper>
  )
})

export default SettingCountInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 8px;

  transition: all 0.3s ease-in-out;
`;

const Input = styled.input`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 61px;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  padding: 0 0 0 8px;
  margin: 0 5px 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  ::placeholder {
    color: ${props => props.theme.line};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
  margin-right: 8px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border: 1px solid ${props => props.theme.buttonStroke};
  border-radius: 8px;
  background: url(${props => props.img}) no-repeat center;
  background-color: ${props => props.theme.buttonFill};

  &:hover {
    cursor: pointer;
  }
`;

const UnitText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 8px;
`;
